import { GridProps } from 'shared/models/components/base.model';
import { handleAdditionalClasses } from 'shared/utilities/dataConversion';

export const Grid = ({ children, columnCount, columnGap, additionalClasses }: GridProps) => {
  const gridClasses = 'w-full grid grid-cols-' + columnCount + ' gap-' + columnGap;
  return (
    <div className={gridClasses + ' ' + handleAdditionalClasses(additionalClasses)}>{children}</div>
  );
};
